import { CloseOnScroll } from '@components/common/CloseOnScroll';
import MaterialIcon from '@components/common/MaterialIcon';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  disabled: boolean;
  onApproveAll: () => void;
  onMarkAllWrong: () => void;
};

export const ConversationReviewBulkActionsMenu: React.FC<Props> = ({
  disabled,
  onApproveAll,
  onMarkAllWrong,
}) => {
  const { t } = useTranslation();

  return (
    <Menu as='div' className='actions-menu'>
      {({ open, close }) => (
        <>
          <CloseOnScroll open={open} close={close} />
          <MenuButton
            disabled={disabled}
            className='conversation-review-modal__bulk-trigger'>
            {t('train-ai.conversation-review.bulk-actions.label')}
            <MaterialIcon icon='expand_less' classes={['!text-sm']} />
          </MenuButton>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'>
            <MenuItems anchor='top end' className='actions-menu__items'>
              <MenuItem>
                <button
                  type='button'
                  className='actions-menu__item actions-menu__item--enabled'
                  onClick={onApproveAll}
                  disabled={disabled}>
                  {t('train-ai.conversation-review.bulk-actions.approve-all')}
                </button>
              </MenuItem>
              <MenuItem>
                <button
                  type='button'
                  className='actions-menu__item actions-menu__item--delete'
                  onClick={onMarkAllWrong}
                  disabled={disabled}>
                  {t('train-ai.conversation-review.bulk-actions.wrong-all')}
                </button>
              </MenuItem>
            </MenuItems>
          </Transition>
        </>
      )}
    </Menu>
  );
};
